import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { IApplicationContext } from 'interfaces/i-application-context-props'
import {
	ApplicationDispatchContext,
	LOAN_APPLICATION_ACTIONS,
} from 'contexts/ApplicationContext'
import { MSP_ACTIONS, MspDispatchContext } from 'components/multistep/Multistep'
import { isApplicantConsentStatusSigned, isSpouseConsentStatusSigned } from 'utils/loanHelpers'
import CircleSpinner from 'components/circle-spinner/CircleSpinner'
import { useApplicationData } from 'hooks/useApplicationData'

export const SignConsentLt = () => {
	const { t } = useTranslation()
	const { loanApplication, dispatchLoanApplication }: IApplicationContext =
		useContext(ApplicationDispatchContext)
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	
	const applicationId =
		loanApplication.applicationData?.loanNumber.toString() ||
		sessionStorage.getItem('applicationid') ||
		null

	const { applicationData } = useApplicationData(
		{ applicationId, t }
	)

	const [movedToNextStep, setMovedToNextStep] = useState<boolean>(false)

	useEffect(() => {
		if (applicationData) {
			dispatchLoanApplication({
				type: LOAN_APPLICATION_ACTIONS.SET_UPDATE_APPLICATIONDATA,
				payload: applicationData,
			})
		}
	}, [applicationData, dispatchLoanApplication])

	useEffect(() => {
		const checkConsentStatus = () => {
			const isConsentSigned = loanApplication.personalData?.isSpouse ? isSpouseConsentStatusSigned(applicationData!) : isApplicantConsentStatusSigned(applicationData!)
			if (isConsentSigned && !movedToNextStep) {
				next()
			}

			if(!isConsentSigned){
				signClick()
			}
		}
		if (applicationData) {
			checkConsentStatus()
		}
	}, [applicationData, loanApplication])

	const signClick = () => {
		const consentSigningUrl = loanApplication.personalData?.isSpouse ? applicationData?.signingUrls.spouseConsent.url : applicationData?.signingUrls.applicantConsent.url
		if(consentSigningUrl)
			window.location.href = consentSigningUrl
	}

	const next = () => {
		setMovedToNextStep(true)
		dispatchMsp({
			type: MSP_ACTIONS.SET_INDEX,
			payload: {
				index: msp.index + 1,
			},
		})
	}

	return (
		<div className="sign-pn">
			<div className="signing-section">
				<CircleSpinner />
			</div>
		</div>
	)
}
